import { DomainEntity, Identifier } from "@/types/domain";
import { Content } from "@/types/squidex";
import { ActivityContentData } from "@features/proposals/types/activity";
import { ContributorBiographyContentData } from "@features/proposals/types/member";

export interface ChangeExtended {
  value: string;
  added?: boolean;
  removed?: boolean;
  files?: string[];
}

export interface ResourceContentDifferenceOutputView<T> {
  readonly id: Identifier;
  readonly published?: T;
  readonly edited?: T;
}

export interface ResourceContentDifferenceEntity<T> extends DomainEntity<
  ResourceContentDifferenceOutputView<T>
> {
  readonly published?: T;
  readonly edited?: T;
}

export type ActivityContentDifferenceEntity = ResourceContentDifferenceEntity<
  Content<ActivityContentData>
>;

export type MemberBiographyContentDifferenceEntity = ResourceContentDifferenceEntity<
  Content<ContributorBiographyContentData>
>;

export const toResourceContentDifferenceEntity = <T>(
  id: Identifier,
  data?: Omit<ResourceContentDifferenceOutputView<T>, "id">,
): ResourceContentDifferenceEntity<T> | undefined => {
  if (!data) {
    return undefined;
  }

  return {
    id,
    published: data.published,
    edited: data.edited,
  };
};
